var React = require('react');

function Checked (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:#fff;fill-rule:evenodd;}")),React.createElement("g",{"id":"Layer_2","data-name":"Layer 2","key":1},React.createElement("g",{"id":"Layer_1-2","data-name":"Layer 1"},React.createElement("path",{"className":"cls-1","d":"M11,.21a.63.63,0,0,0-.94,0L4.21,6.51,1.13,3.19a.63.63,0,0,0-.94,0,.77.77,0,0,0,0,1L3.74,8a.63.63,0,0,0,.94,0L11,1.22a.75.75,0,0,0,0-1"})))]);
}

Checked.defaultProps = {"viewBox":"0 0 11.2 8.23"};

module.exports = Checked;

Checked.default = Checked;
